<custom-table [config]="customTable">
</custom-table>
<app-procesar-tramite></app-procesar-tramite>
<p-confirmPopup/>
